export default "__VITE_ASSET__BBeZHYXe__"